import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Pencil, Code, Rocket, Zap } from 'lucide-react';

const HowWeWork = () => {
  const workProcess = [
    {
      icon: Lightbulb,
      title: "Discovery Session",
      description: "We dive deep into your brand identity, target audience, and desired emotional impact. This isn't about layouts—it's about defining the core experience and vibe of your site.",
      number: "01"
    },
    {
      icon: Pencil,
      title: "Concept Preview",
      description: "You get initial visual direction: layout ideas, animation concepts, and style direction. Delivered as mockups or rough builds for your feedback.",
      number: "02"
    },
    {
      icon: Code,
      title: "Iteration Loop",
      description: "This is where we win: rapid changes based on your feedback. Multiple refinement cycles with speed and flexibility that traditional agencies can't match.",
      number: "03"
    },
    {
      icon: Rocket,
      title: "Final Build & Launch",
      description: "Your website is fully assembled, tested across devices, and deployed live. Clean, performant, and ready to impress.",
      number: "04"
    },
    {
      icon: Zap,
      title: "Growth & Maintenance",
      description: "Optional ongoing support: SEO optimization, performance tracking, and continuous improvements to keep your site at peak performance.",
      number: "05"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section className="how-we-work-section" id="how-we-work">
      <div className="how-we-work-container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8 }}
        >
          OUR PROCESS
        </motion.h2>
        <motion.p 
          className="section-subtitle"
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          A structured, collaborative approach that delivers results fast
        </motion.p>
        
        <motion.div 
          className="work-process-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-10%" }}
        >
          {workProcess.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div key={index} className="work-process-card" variants={itemVariants}>
                <div className="process-number">{step.number}</div>
                <div className="process-icon-wrapper">
                  <Icon className="process-icon" />
                </div>
                <h3 className="process-title">{step.title}</h3>
                <p className="process-description">{step.description}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default HowWeWork;
